import { inject, Injectable } from "@angular/core";
import { Logger } from "./logger.service";
import { WindowRef } from "@Shared2/window-ref.service";
import { LogLevel } from "@Assistant/SystemTypes/Logging/LogLevel";

@Injectable({ providedIn: "root" })
export class CspViolationTracker {

    private logger = inject(Logger);
    private windowRef = inject(WindowRef);

    trackViolations() {

        this.windowRef.nativeWindow.addEventListener("securitypolicyviolation", event => {

            if (event.blockedURI === "inline") {

                this.logger.log({
                    logLevel: LogLevel.Warning,
                    eventName: "CSP_EXTRA_VIOLATION_INFO",
                    payload: {
                        documentUri: event.documentURI,
                        viloatedDirective: event.violatedDirective,
                        elementCode: (event.target as HTMLElement).outerHTML,
                        elementPath: this.getPathToElement(event.target as HTMLElement),
                    },
                });
            }
        });
    }

    private getPathToElement(element: HTMLElement) {

        let currentElement = element;
        const getElementInfo = (element: HTMLElement) => `${element.localName}${element.id ? `#${element.id}` : ""}${element.className ? `.${element.className.replace(/\s/g, ".")}` : ""}`;
        const path = [];

        while (currentElement) {

            path.push(getElementInfo(currentElement));
            currentElement = currentElement.parentElement;
        }

        return path.reverse();
    }
}
